import { useCallback, useEffect, useMemo } from 'react';
import { clearErrorScreenData, selectAuthZoneConfig, selectErrorReason, selectErrorRetryCount, selectErrorScreenType, setErrorReason, setErrorRetryCount, setErrorScreenType, setIsHistoryCalled } from "../../../../../entities/settings/model";
import { FSMStages, useAppDispatch, useAppSelector, useFSM } from "../../../../../shared/model";
import { ErrorReason, ErrorScreenType } from "../../../../../shared/config";
import { setReconnectCount } from "../../../../../entities/socket/model";
import { useCaptchaContext } from "../../../../../entities/captcha/model";
import { useOnlineStatus } from "../../../../../shared/lib";
import { getContent } from "./utils";
var MAX_RETRY_COUNT = 10;
export var useErrorScreen = function useErrorScreen() {
  var errorReason = useAppSelector(selectErrorReason);
  var errorScreenType = useAppSelector(selectErrorScreenType);
  var _useAppSelector = useAppSelector(selectAuthZoneConfig),
    _useAppSelector$zoneT = _useAppSelector.zoneType,
    zoneType = _useAppSelector$zoneT === void 0 ? 'unauthorized' : _useAppSelector$zoneT;
  var _useCaptchaContext = useCaptchaContext(),
    captchaStage = _useCaptchaContext.captchaStage,
    handleChangeStage = _useCaptchaContext.handleChangeStage;
  var isOnline = useOnlineStatus();
  var errorRetryCount = useAppSelector(selectErrorRetryCount);
  var _useFSM = useFSM(),
    changeStage = _useFSM.changeStage;
  var dispatch = useAppDispatch();
  var onUpdateClick = useCallback(function () {
    dispatch(setErrorRetryCount(errorRetryCount + 1));
    if (!isOnline) {
      return;
    }
    dispatch(clearErrorScreenData());
    if (errorReason === ErrorReason.CONTENT_LOAD || errorReason === ErrorReason.HISTORY_LOAD) {
      dispatch(setIsHistoryCalled(false));
      changeStage(FSMStages.LOAD_DATA);
      return;
    }
    if (errorReason === ErrorReason.VALIDATE_CAPTCHA) {
      changeStage(FSMStages.CAPTCHA_NEEDED);
      return;
    }
    if (errorReason === ErrorReason.REFRESH_TOKEN) {
      handleChangeStage('start');
      changeStage(FSMStages.CAPTCHA_NEEDED);
      return;
    }
    if (errorReason === ErrorReason.WEBSOCKET_CONNECTION) {
      dispatch(setReconnectCount(0));
      changeStage(FSMStages.CONNECTING);
      return;
    }
    if (zoneType === 'authorized' || captchaStage === 'end') {
      dispatch(setIsHistoryCalled(false));
      changeStage(FSMStages.LOAD_DATA);
    } else {
      changeStage(FSMStages.CAPTCHA_NEEDED);
    }
  }, [errorReason, captchaStage, zoneType, isOnline]);
  useEffect(function () {
    if (errorRetryCount >= MAX_RETRY_COUNT) {
      dispatch(setErrorScreenType(ErrorScreenType.BLOCK));
      dispatch(setErrorReason(ErrorReason.UNKNOWN));
    }
  }, [errorRetryCount]);
  return useMemo(function () {
    return {
      content: getContent(errorRetryCount >= MAX_RETRY_COUNT ? ErrorScreenType.BLOCK : errorScreenType),
      onUpdateClick: onUpdateClick
    };
  }, [errorScreenType, errorRetryCount, onUpdateClick]);
};